import { useFirebaseToken } from '@/hooks/useFirebaseUser/useFirebaseToken'

import { useContactsServiceGetV1IndividualsByIndividualIdContacts } from '../client/queries'
import { ContactList } from '../client/requests'

export type Contact = ContactList[number]

export const useContacts = (individualId?: string) => {
  const token = useFirebaseToken()

  return useContactsServiceGetV1IndividualsByIndividualIdContacts(
    { individualId: individualId! },
    undefined,
    {
      enabled: !!token && !!individualId,
    },
  )
}
